import { render } from "./markerDetail.vue?vue&type=template&id=2c4c1fb0&scoped=true&ts=true"
import script from "./markerDetail.vue?vue&type=script&lang=ts"
export * from "./markerDetail.vue?vue&type=script&lang=ts"

import "./markerDetail.vue?vue&type=style&index=0&id=2c4c1fb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4c1fb0"]])

export default __exports__